import {
  getGuruInsightRoutine,
  clearGuruInsightRoutine
} from 'ducks/guruInsight/actions'
import emptyGuruInsightState from 'ducks/guruInsight/state'

export default (state = emptyGuruInsightState, action) => {
  switch (action.type) {
    case getGuruInsightRoutine.REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      }
    case getGuruInsightRoutine.SUCCESS:
      return {
        ...state,
        insight: action.payload,
        error: null
      }
    case getGuruInsightRoutine.FAILURE:
      return {
        ...state,
        error: action.payload
      }
    case getGuruInsightRoutine.FULFILL:
      return {
        ...state,
        isLoading: false
      }
    case clearGuruInsightRoutine.TRIGGER:
      return {
        ...emptyGuruInsightState
      }
    default:
      return state
  }
}
